<template>
  <template v-if="items && items.length > 0">
    <TGrid :gap-y="8" class="s-reviews">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="col-span-12 md:col-span-6"
      >
        <TReview v-bind="item" :variant="variant" />
      </div>
    </TGrid>
  </template>
</template>

<script setup lang="ts">
import {
  type Props,
  type reviewVariant,
} from '~~/modules/design-system/components/t-review/index.vue'

export interface propsInterface {
  items: Array<Props>
  variant?: reviewVariant
}

withDefaults(defineProps<propsInterface>(), {
  variant: 'default',
})
</script>
